// extracted by mini-css-extract-plugin
export default {"columns":"hours-of-operation_columns__rcRm5"};